<template>
  <CheckboxGroup
    v-model="data.value"
    :options="data.options"
    @change="bindChange"
  >
    <CheckboxItem
      v-for="(item, index) in data.options"
      :key="index"
      :value="item.key"
      :data="item"
      :rows="data.show_type"
    >
      <div style="height: 100%">
        <div
          class="checkbox-text"
          :style="{
            background: data.value.includes(item.key)
              ? theme.checkColor
              : theme.notCheckColor
          }"
          v-if="item.value && !item.que_answer_icon"
          >{{ item.value }}</div
        >
        <div class="radio-image" v-if="item.que_answer_icon">
          <img style="width: 100%" :src="item.que_answer_icon" alt="" />
          <div
            class="active iconfont icon-gou"
            v-show="data.value == item.key"
            :style="{ background: theme.checkColor }"
          ></div>
        </div>
      </div>
    </CheckboxItem>
    <div v-show="showOther && !showOverlay" class="raido-input" @click.stop>
      <van-field
        class="answer-input"
        readonly
        @click="bindShowOverlay"
        v-model="otherInput"
        placeholder="请在这里填写吧"
        @input="bindInput"
      />
    </div>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper" @click.stop>
        <van-field
          class="answer-input"
          ref="answerInput"
          @blur="bindBlur"
          v-model="otherInput"
          placeholder="请在这里填写吧"
          @input="bindInput"
        />
      </div>
    </van-overlay>
  </CheckboxGroup>
</template>
<script>
import CheckboxItem from './checkbox/checkbox.vue'
import CheckboxGroup from './checkbox/checkbox-group.vue'
export default {
  components: {
    CheckboxGroup,
    CheckboxItem
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showOverlay: false,
      curValue: [],
      showOther: false, //显示其他输入框
      otherInput: '',
      optionsIndex: -1
    }
  },
  watch: {
    'data.id'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    bindShowOverlay() {
      this.showOverlay = true
      this.$nextTick(() => {
        this.$refs.answerInput.focus()
      })
    },
    bindBlur() {
      this.showOverlay = false
    },
    init() {
      this.curValue = []
      this.showOther = false
      this.otherInput = ''
      this.optionsIndex = -1
      this.data.options.map((item, index) => {
        if (item.que_answer_attr) {
          this.optionsIndex = index
        }
        if (item.inputValue) {
          this.otherInput = item.inputValue
        }
        if (item.que_answer_attr && this.data.value.includes(item.key)) {
          this.showOther = true
        }
      })
    },
    bindInput(val) {
      this.data.options[this.optionsIndex].inputValue = val
    },
    bindChange(value, changeValue) {
      this.curValue = value
      this.$emit('change', value)
      this.showOther =
        this.optionsIndex >= 0
          ? value.includes(this.data.options[this.optionsIndex].key)
          : false
      if (
        this.showOther &&
        this.data.options[this.optionsIndex].key == changeValue
      ) {
        this.bindShowOverlay()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.checkbox-group {
  ::v-deep .van-overlay {
    background-color: rgba(0, 0, 0, 0);
  }
}
.checkbox-text {
  height: 100%;
  padding: 14px 16px;
  border-radius: 8px;
  box-sizing: border-box;
}

.raido-input {
  margin: 10px auto 0px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.radio-image {
  position: relative;

  .active {
    position: absolute;
    right: 24px;
    top: 50%;
    color: #fff;
    transform: translate(0%, -50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #9f91fe;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.answer-input {
  border-radius: 22px;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid #ff2c4c;
}
.wrapper {
  padding: 0px 30px;
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 500px;
  transition: bottom 0.3s ease;
}
</style>
